import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { hideVisually } from 'polished'

import {
  borderRadius,
  breakpoint,
  colorUtils,
  duration,
  easing,
  size,
} from '@twisto/styles'

import {
  CHECKBOX_ICON_SPACING,
  CHECKBOX_ICON_WIDTH,
} from './checkbox-icon/checkbox-icon.styles'

const rowHeight = 48

export const root = (theme: Theme) => css`
  padding: ${size[8]};
  min-height: ${rowHeight}px;
  border-radius: ${borderRadius.sm};
  border: none;
  color: ${theme.palette.neutral[800]};
  background: transparent;
`

export const checkboxIcon = css`
  margin-right: ${CHECKBOX_ICON_WIDTH};
`

export const input = (theme: Theme) => css`
  ${hideVisually()}

  & + div {
    transition: box-shadow ${duration.short}ms ${easing.easeInOut};
    outline: none;
  }

  &:focus + div,
  &:focus:hover + div {
    box-shadow: 0 0 0
      ${`${size[4]} ${colorUtils.colorWithOpacity(
        theme.palette.brand[200],
        0.24
      )}`};
  }

  &:active + div,
  &:active:hover + div {
    box-shadow: 0 0 0 ${`${size[4]} ${theme.palette.neutral[300]}`};
  }

  &:hover + div {
    box-shadow: 0 0 0 ${`${size[4]} ${theme.palette.neutral[200]}`};
  }

  &:disabled + div {
    box-shadow: none;
  }
`

export const inputError = (theme: Theme) => css`
  &:focus + div {
    border-color: ${theme.palette.error[500]};
  }
`

export const formHelperText = css`
  margin-left: calc(${CHECKBOX_ICON_WIDTH} + ${CHECKBOX_ICON_SPACING});
`

export const label = css`
  display: flex;
`

export const defaultLabelText = css`
  line-height: 1.6;
  font-size: 13px;
  letter-spacing: -0.13px;
  margin-top: 2px;

  ${breakpoint.up('sm')} {
    font-size: 15px;
    letter-spacing: -0.15px;
    margin-top: 0;
  }
`

export const smallerLabelText = css`
  line-height: 1.6;
  font-size: 11px;
  letter-spacing: -0.11px;
  margin-top: 4px;
`
